/** @format */

module.exports = {
  reactivationEvents: Object.freeze({
    flowClosed: "flowClosed",
    tabClosed: "tabClosed",
  }),
};



// WEBPACK FOOTER //
// ./src/partners/config/constants.js